import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

const DATE_FORMAT = "YYYY-MM-DD";

function oneYearAgo() {
  return dayjs.utc().subtract(1, "year").format(DATE_FORMAT);
}

export function now() {
  return dayjs().format(DATE_FORMAT);
}

export function lastWeek() {
  const lastWeek = dayjs().subtract(7, "days");
  const minDate = oneYearAgo();

  if (lastWeek.isBefore(minDate, "day")) {
    return minDate;
  }

  return lastWeek.format(DATE_FORMAT);
}

export function getDateLimits() {
  return {
    min: oneYearAgo(),
    max: dayjs().format(DATE_FORMAT),
  };
}
